import styled from 'styled-components';

const ButtonGrid = styled.div.attrs({
  role: 'group',
})`
  margin: -0.5rem -0.25rem 0.5rem;
  display: flex;
  flex-wrap: wrap;

  & > * {
    margin: 0.4rem 0.25rem;
    flex: 1 1 calc(25% - 0.5rem);
  }
`;

export default ButtonGrid;
